import {
  CATEGORIE_PRESSE,
  CATEGORIE_SPONSORING,
  CATEGORIE_SALON,
  CATEGORIE_AUTRE,
} from '@/configuration/catalogue/produitConf';

export const LISTE_PRODUITS_MODULE_PRESSE = {
  title: {
    [CATEGORIE_PRESSE]: 'Liste produit presse',
    [CATEGORIE_SPONSORING]: 'Liste produit sponsoring / événementiel',
    [CATEGORIE_SALON]: 'Liste produit salon',
    [CATEGORIE_AUTRE]: 'Liste produit autre',
  },
  tab: {
    reference: 'Référence',
    type: 'Type',
    typeSupport: 'Type support',
    label: 'Libellé',
    marche: 'Marché',
    fournisseur: 'Fournisseur',
    societe: 'Société',
    agence: 'Agence',
    actif: 'Archivé',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
  },
  button: {
    newProduct: 'Nouveau produit',
  },
  filtre: {
    reference: 'Référence',
    libelle: 'Libellé',
    actif: 'Actif',
    societe: 'Societé',
    agence: 'Agence',
  },
};
export const NOTHING = null;
